import { ProjectsProps } from "@/types/component.types";
import SectionWrapper from "@/components/ui/SectionWrapper";
import Text from "@/components/ui/Text";
import Headline from "@/components/ui/Headline";
import Project from "@/components/Project.component";
import Blobs from "@/components/ui/Blobs";

export default function Projects({ 
  blok, 
  language = "de"
}: { 
  blok: ProjectsProps,
  language?: "de" | "en"
}) {

  const headlineBlok = blok.headline?.[0];

  return (
    <SectionWrapper 
      className="relative w-full" 
      id="projects"
      spaces={blok.spaces}
    >
      
      <Blobs variant="projects" />

      <div className="container relative z-10 px-4 md:px-8">
        
        {headlineBlok && (
          <Headline
            text={headlineBlok.text}
            level={headlineBlok.level}
          />
        )}

        {blok.subheadline && (
          <Text className="mt-4 max-w-[768px]">{blok.subheadline}</Text>
        )}

        <div className="flex flex-col xl:mt-6 relative">
          {blok.projects && blok.projects.map((nestedBlok: any) => (
            <Project
              blok={nestedBlok} 
              key={nestedBlok._uid} 
              language={language} 
            />
          ))}
        </div>

        {blok.caption && (
          <Text variant="detail" className="mt-8 text-center opacity-60 max-w-2xl mx-auto">
            {blok.caption}
          </Text>
        )}

      </div>
      
    </SectionWrapper>
  );
};